import { v4 as uuidv4 } from 'uuid'

export function generateUniqueUserId(): string {
  return uuidv4()
}
